import {FromPaymentScreenActionType} from "../Constants/FromPaymentScreenActionType";

export const setFromPaymentScreen = selectedTeams => {
	return {
		type: FromPaymentScreenActionType.FromPaymentScreen,
		payload: selectedTeams,
	};
};
